import { Component } from "@angular/core";
import { Router } from "@angular/router";

import { CustomModal } from "../../../core/components/base-modals";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";

import { BpModalCanDismiss } from "@models/interfaces/bp-modal-can-dismiss";
import { Announcement } from "@models/announcement";

import { config } from "config/environment";
import { BpModalHasSave } from "@models/interfaces/bp-modal-has-save";

@Component({
	templateUrl: "./announcement-modal.component.html",
	styleUrls: ["./announcement-modal.component.scss"],
	standalone: false
})
export class AnnouncementModalComponent extends CustomModal implements BpModalCanDismiss, BpModalHasSave {
	private _close: boolean = false;

	public buttonOkKey: string = "got_it"; // Default

	public constructor(
		private apicallService: ApicallService,
		private router: Router
	) {
		super();
	}

	public modalCanDismiss(): boolean {
		return this._close;
	}

	public save(): void {
		this._close = true;
		this.apicallService.post("user/announcement/" + this.announcement.getId(), new ApicallOption()).subscribe();
		this.close();
	}

	public get announcement(): Announcement {
		return this.data;
	}

	public isInternalLink(): boolean {
		return this.data.getLink().startsWith(config.appUrl);
	}

	public onButtonClick(): void {
		this._close = true;

		// Mark as read to the API
		this.apicallService.post("user/announcement/" + this.announcement.getId(), new ApicallOption()).subscribe();

		this.close();

		// Redirect user
		if (this.announcement.hasLink()) {
			if (this.isInternalLink()) {
				// Webapp route:
				const relativeUrl = this.data.getLink().substring(config.appUrl.length);
				setTimeout(() => this.router.navigateByUrl(relativeUrl), 500);
			} else {
				// External URL:
				window.open(this.announcement.getLink(), "_blank");
			}
		}
	}
}
